export const buttonFilledLeftStyle1 = {
  borderTopLeftRadius: '60px',
  borderBottomLeftRadius: '60px',
  border: '1px solid #BEC8C9',
  backgroundColor: '#CCE8E9'
}
export const buttonFilledLeftStyle = {
  borderTopLeftRadius: '60px',
  borderBottomLeftRadius: '60px',
  border: '1px solid #BEC8C9'
}
export const buttonFilledRightStyle = {
  borderTopRightRadius: '60px',
  borderBottomRightRadius: '60px',
  border: '1px solid #BEC8C9'
}
export const buttonFilledRightStyle1 = {
  borderTopRightRadius: '60px',
  borderBottomRightRadius: '60px',
  border: '1px solid #BEC8C9',
  backgroundColor: '#CCE8E9'
}
export const selectedTextStyle = {
  color: 'var(--M3-sys-light-on-secondary-container, #041F21)',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '0.1px',
  textTransform: 'none'
};
export const unselectedTextStyle = {
  color: 'var(--M3-sys-light-on-surface, #191C1C)',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '0.1px',
  textTransform: 'none'
};